import { QueryKeys } from '../../utils/queryKeys';

export const postModuleAssessmentKeys = {
    all: [QueryKeys.GET_POST_MODULE_QUESTION],
    getPostModuleAssessmentKeys: () => [...postModuleAssessmentKeys.all],
};